/* istanbul ignore file */
import React, { useState } from 'react';
import { useAuthorization } from 'framework/authorization';
import { Button, UploadIcon } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';
import UploadFileForm from 'domain/finance/costAccounting/reconcilation/shared/UploadFileForm';
import { UPLOAD_BANK_STATEMENT } from 'domain/finance/costAccounting/reconcilation/useReconciliationService';

const UploadFileButton = ({ execute }: { execute: () => void }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { isGranted } = useAuthorization();

  const closeModal = () => {
    setModalOpen(false);
  };

  return isGranted(UPLOAD_BANK_STATEMENT) ? (
    <>
      <Button
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          setModalOpen(true);
          (e.target as HTMLElement).blur();
        }}
        startIcon={<UploadIcon sx={{ opacity: 0.9 }} />}
      >
        Upload statement
      </Button>
      <Modal
        backdrop="static"
        isOpen={modalOpen}
        title="Upload statement"
        onToggle={closeModal}
        hasCancelButton={false}
      >
        <UploadFileForm closeModal={closeModal} modalOpen={modalOpen} execute={execute} />
      </Modal>
    </>
  ) : null;
};

export default UploadFileButton;
